import { CalendarPlus, Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { downloadICS, googleCalendarUrl } from "../lib/calendar";

export function CalendarMenu({ plan, size = "default", variant = "outline", iconOnly = false, testId = "add-to-calendar-btn" }) {
  const google = () => {
    window.open(googleCalendarUrl(plan), "_blank", "noopener,noreferrer");
  };
  const apple = () => {
    downloadICS(plan);
    toast.success("Calendar file downloaded", { description: "Open it to add all stops to Apple or Outlook Calendar." });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={testId} size={size} variant={variant} className="rounded-full font-semibold" title="Add to calendar">
          <CalendarPlus size={size === "sm" ? 15 : 16} className={iconOnly ? "" : "mr-2"} />
          {!iconOnly && "Add to calendar"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-xl">
        <DropdownMenuItem data-testid="calendar-google-item" onClick={google} className="cursor-pointer gap-2 py-2.5">
          <ExternalLink size={15} /> Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="calendar-ics-item" onClick={apple} className="cursor-pointer gap-2 py-2.5">
          <Download size={15} /> Apple / Outlook (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
